export default __webpack_public_path__ + "static/media/3001.472d8f25.jpg";